import { Columns } from '@shared/interfaces/table/column-config';
import { LinkCellComponent } from '@shared/components/table/cells/link-cell/link-cell.component';
import {
  addressPartial,
  meteringPointSubTypePartial,
  meterQuadrantPartial,
  meterReadingOccurrencePartial
} from '@shared/columns/meteringpoint.columns';
import { meteringPointTypePartial } from '@shared/partials/meteringpointtype-partial.table';
import { physicalStatusPartial } from '@shared/partials/physicalstatus.partial';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { StatusCellComponent } from '@shared/components/table/cells/status-cell/status-cell.component';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { validFromPartialTable } from '@shared/partials/validfrom-partial.table';
import { validToPartialTable } from '@shared/partials/validto-partial.table';
import { datahubPartial } from '@shared/partials/datahub.partial';
import { settlementmethodPartial } from '@shared/partials/settlementmethod.partial';
import { existsInDatahub } from '@shared/partials/existsindatahub.partial';
import { resolutionPartial } from '@shared/partials/resolution.partial';
import { DATE_TIME_FORMAT } from '@app/core/constants/date-time-format';
import { DecimalCellComponent } from '@shared/components/table/cells/decimal-cell/decimal-cell.component';
import { isChildPartial } from '@shared/partials/isChildPartial';
import { hasBalanceSupplierPartial } from '@shared/partials/has-balance-supplier.partial';

export const dashboardMeteringPointIdentificationPartial: Columns<any> = {
  title: 'dashboard.table.meteringpointid',
  key: 'meteringPointIdentification',
  width: 200,
  cellRenderer: LinkCellComponent,
  cellRendererParams: {
    url: '/meteringpoint',
    urlReference: 'meteringPointIdentification',
  }
}

export const dashboardMeteringPointAddressPartial: Columns<any> = {
  ...addressPartial,
}

export const dashboardMeteringPointTypePartial: Columns<any> = {
  ...meteringPointTypePartial,
  key: 'typeOfMeteringPoint',
}

export const dashboardPhysicalStatusPartial: Columns<any> = {
  ...physicalStatusPartial,
}

export const dashboardPartyNamePartial: Columns<any> = {
  title: 'dashboard.table.partyname',
  key: 'partyName',
}

export const dashboardCreatedPartial: Columns<any> = {
  title: 'dashboard.table.created',
  key: 'created',
  cellRenderer: DateCellComponent,
  cellRendererParams: {
    format: DATE_TIME_FORMAT,
  }
}

export const dashboardCreatedTs: Columns<any> = {
  ...dashboardCreatedPartial,
  key: 'createdTs',
}


export const dashboardCreatedBy: Columns<any> = {
  title: 'dashboard.table.createdby',
  key: 'createdBy',
}

export const dashboardCreatedReceivedPartial: Columns<any> = {
  title: 'dashboard.table.createdreceived',
  key: 'created',
  cellRenderer: DateCellComponent,
}

export const dashboardCompletionPartial: Columns<any> = {
  title: 'dashboard.table.completion',
  key: 'occurrence',
  cellRenderer: DateCellComponent,
}

export const dashboardUserResponse: Columns<any> = {
  title: 'dashboard.table.userresponse',
  key: 'userResponse',
  cellRenderer: StatusCellComponent,
  cellRendererParams: {
    required: { color: 'bg-yellow-500', label: 'dashboard.userresponse.required' },
    approved: { color: 'bg-green-500', label: 'dashboard.userresponse.approved' },
    rejected: { color: 'bg-red-500', label: 'dashboard.userresponse.rejected' },
    notrequired: { color: 'bg-gray-100', label: 'dashboard.userresponse.notrequired' },
    notspecified: { color: 'bg-gray-100', label: '' },
  }
}

export const dashboardActionResponsePartial: Columns<any> = {
  title: 'dashboard.table.actionresponse',
  key: 'actionResponse',
  cellRenderer: StatusCellComponent,
  cellRendererParams: {
    required: { color: 'bg-yellow-500', label: 'dashboard.actionresponse.required' },
    approved: { color: 'bg-green-500', label: 'dashboard.actionresponse.approved' },
    manuallyhandled: { color: 'bg-green-500', label: 'dashboard.actionresponse.manuallyhandled' },
    rejected: { color: 'bg-red-500', label: 'dashboard.actionresponse.rejected' },
    notrequired: { color: 'bg-gray-100', label: 'dashboard.actionresponse.notrequired' },
    notspecified: { color: 'bg-gray-100', label: '' },
  }
}

export const dashboardStatusPartial: Columns<any> = {
  title: 'dashboard.table.status',
  key: 'status',
  cellRenderer: StatusCellComponent,
  cellRendererParams: {
    required: { color: 'bg-yellow-500', label: 'dashboard.status.required' },
    approved: { color: 'bg-green-500', label: 'dashboard.status.approved' },
  }
}

export const dashboardCancelledBySupplierPartial: Columns<any> = {
  title: 'dashboard.table.status',
  key: 'isCancelledBySupplier',
  sortable: false,
  cellRenderer: StatusCellComponent,
  cellRendererParams: {
    '1': { color: 'bg-red-500', label: 'dashboard.servicerequest.status.cancelledbysupplier' },
    '0': { color: 'bg-gray-100', label: '' },
  }
}

export const dashboardReasonTextPartial: Columns<any> = {
  title: 'dashboard.table.reason',
  key: 'reasonText',
}

export const dashboardPipelineTypePartial: Columns<any> = {
  title: 'dashboard.table.pipelinetype',
  key: 'pipelineType',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    notspecified: 'enum.pipelinetype.notspecified',
    request: 'enum.pipelinetype.request',
    response: 'enum.pipelinetype.response',
    notify: 'enum.pipelinetype.notify',
    todo: 'enum.pipelinetype.todo',
    todohandled: 'enum.pipelinetype.todohandled',
  }
}

export const dashboardServiceType: Columns<any> = {
  title: 'dashboard.table.servicetype',
  key: 'serviceType',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    metercheck: 'dashboard.servicerequest.metercheck',
    flexchange: 'dashboard.servicerequest.flexchange',
    nonprofiledchange: 'dashboard.servicerequest.nonprofiledchange',
    readingrequest: 'dashboard.servicerequest.readingrequest',
  }
}

export const dashboardMeterNumber: Columns<any> = {
  title: 'dashboard.table.meternumber',
  key: 'meterNumber',
}

export const dashboardMappedQuadrant: Columns<any> = {
  title: 'dashboard.table.mappedquadrant',
  key: 'mappedQuadrant',
}

export const dashboardNonMappedQuadrant: Columns<any> = {
  title: 'dashboard.table.nonmappedquadrant',
  key: 'nonMappedQuadrant',
}

export const dashboardConsumptionNonMappedQuadrant: Columns<any> = {
  title: 'dashboard.table.consumptionnonmappedquadrant',
  key: 'consumptionNonMappedQuadrant',
}

export const dashboardProductionObligation: Columns<any> = {
  title: 'dashboard.table.productionobligation',
  key: 'productionObligation',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    true: 'common.yes',
    false: 'common.no',
  }
}

export const dashboardDataHubStatus: Columns<any> = {
  ...datahubPartial,
}

export const dashboardModifiedTs: Columns<any> = {
  title: 'dashboard.table.modifiedts',
  key: 'modifiedTs',
  cellRenderer: DateCellComponent,
}

export const dashboardChargeType: Columns<any> = {
  title: 'dashboard.table.chargetype',
  key: 'chargeType',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    notspecified: 'enum.chargetype.notspecified',
    subscription: 'enum.chargetype.subscription',
    fee: 'enum.chargetype.fee',
    tariff: 'enum.chargetype.tariff',
  }
}

export const dashboardChargeTypeId: Columns<any> = {
  title: 'dashboard.table.chargeinformationidentification',
  key: 'chargeTypeId',
  cellRenderer: LinkCellComponent,
  cellRendererParams: {
    url: '/chargeinformation',
    urlReference: 'chargeInformationDeltaId',
  }
}

export const dashboardChargeInformation: Columns<any> = {
  title: 'dashboard.table.chargeinformation',
  key: 'chargeInformationType'
}

export const dashboardChargeInformationIdentification: Columns<any> = {
  title: 'dashboard.table.chargeinformationidentification',
  key: 'chargeInformationIdentification',
  cellRenderer: LinkCellComponent,
  cellRendererParams: {
    url: '/chargeinformation',
    urlReference: 'chargeInformationIdentification',
  }
}

export const dashboardValidFrom: Columns<any> = {
  ...validFromPartialTable,
}

export const dashboardValidTo: Columns<any> = {
  ...validToPartialTable,
}

export const dashboardChargeOccurrences: Columns<any> = {
  title: 'dashboard.table.chargeoccurrences',
  key: 'chargeOccurrences',
}

export const dashboardStatusReasonCode: Columns<any> = {
  title: 'dashboard.table.statusreasoncode',
  key: 'statusReasonCode',
}

export const dashboardPhysicalStatusOfMeteringPoint: Columns<any> = {
  ...physicalStatusPartial,
  key: 'physicalStatusOfMeteringPoint',
}

export const dashboardMeterReadingOccurrence: Columns<any> = {
  ...meterReadingOccurrencePartial,
  title: 'dashboard.table.meterreadingoccurrence',
  key: 'meterReadingOccurrence',
}

export const dashboardOccurrence: Columns<any> = {
  title: 'dashboard.table.occurrence',
  key: 'occurrence',
  cellRenderer: DateCellComponent,
}

export const dashboardChangeDate: Columns<any> = {
  title: 'common.changedate',
  key: 'changeDate',
  cellRenderer: DateCellComponent,
}

export const dashboardQuadrant: Columns<any> = {
  ...meterQuadrantPartial,
  key: 'quadrant',
}

export const dashboardMessagesCount: Columns<any> = {
  title: 'dashboard.table.messagescount',
  key: 'messagesCount',
}

export const dashboardOldestDayOfWork: Columns<any> = {
  title: 'dashboard.table.oldestdayofwork',
  key: 'oldestDayOfWork',
  cellRenderer: DateCellComponent,
}

export const dashboardSerialNumber: Columns<any> = {
  title: 'dashboard.table.serialnumber',
  key: 'serialNumber',
}

export const dashboardMeterType: Columns<any> = {
  title: 'dashboard.table.metertype',
  key: 'type',
}

export const dashboardMetringPointSubType: Columns<any> = {
  ...meteringPointSubTypePartial,
  key: 'subTypeOfMeteringPoint'
}

export const dashboardSettlementMethod: Columns<any> = {
  ...settlementmethodPartial,
}

export const dashboardAlternateMeterNumber: Columns<any> = {
  title: 'dashboard.table.alternatemeternumber',
  key: 'alternateMeterNumber',
}

export const dashboardBalanceSupplierDate: Columns<any> = {
  title: 'dashboard.table.balancesupplierdate',
  key: 'balanceSupplierDate',
  cellRenderer: DateCellComponent,
}

export const dashboardDescription: Columns<any> = {
  title: 'dashboard.table.description',
  key: 'description'
}

export const dashboardLongDescription: Columns<any> = {
  title: 'dashboard.table.longdescription',
  key: 'longDescription'
}

export const dashboardOwnerEnergyParty: Columns<any> = {
  title: 'dashboard.table.ownerenergyparty',
  key: 'ownerEnergyParty'
}

export const dashboardModifiedBy: Columns<any> = {
  title: 'dashboard.table.modifiedby',
  key: 'modifiedBy'
}

export const dashboardExistsInDataHub: Columns<any> = {
  ...existsInDatahub,
  key: 'existsInDataHub'
}

export const dashboardObservationPeriod: Columns<any> = {
  ...resolutionPartial,
  title: 'dashboard.table.meterreadingoccurrence',
  key: 'observationPeriod'
}

export const dashboardAutomationStarted: Columns<any> = {
  title: 'dashboard.table.automationstarted',
  key: 'automationStarted',
  cellRenderer: DateCellComponent,
}

export const dashboardReceivingTime: Columns<any> = {
  title: 'dashboard.table.receivingtime',
  key: 'receivingTime',
  cellRenderer: DateCellComponent,
}

export const dashboardConnectivityStatus: Columns<any> = {
  title: 'meter.connectivitystatus',
  key: 'connectivityStatus',
  cellRenderer: DateCellComponent,
}

export const dashboardDateOfWork: Columns<any> = {
  title: 'dashboard.timeseries.missing.dateofwork',
  key: 'dateOfWork',
  cellRenderer: DateCellComponent,
}

export const dashboardMainMeterNumber: Columns<any> = {
  title: 'dashboard.table.mainmeternumber',
  key: 'mainMeterNumber'
}

export const dashboardVerificationMeterNumber: Columns<any> = {
  title: 'dashboard.table.verificationmeternumber',
  key: 'verificationMeterNumber'
}

export const dashboardMeterReadingTs: Columns<any> = {
  title: 'dashboard.timeseries.meterreadingts',
  key: 'meterReadingTs',
  cellRenderer: DateCellComponent,
  cellRendererParams: {
    format: DATE_TIME_FORMAT,
  }
}

export const dashboardMeterReadingValue: Columns<any> = {
  title: 'dashboard.table.meterreadingvalue',
  key: 'meterReadingValue',
  cellRenderer: DecimalCellComponent,
  cellRendererParams: {
    decimals: 3,
  }
}

export const dashboardVerificationMeterReadingValue: Columns<any> = {
  title: 'dashboard.table.verificationmeterreadingvalue',
  key: 'verificationMeterReadingValue',
  cellRenderer: DecimalCellComponent,
  cellRendererParams: {
    decimals: 3,
  }
}

export const dashboardRelativeDeviation: Columns<any> = {
  title: 'meteringpoint.meter.createcontrolmeter.relativedeviation',
  key: 'relativeDeviation',
  cellRenderer: DecimalCellComponent,
  cellRendererParams: {
    decimals: 4,
  }
}

export const dashboardAbsoluteDeviation: Columns<any> = {
  title: 'meteringpoint.meter.createcontrolmeter.absolutedeviation',
  key: 'absoluteDeviation',
  cellRenderer: DecimalCellComponent,
  cellRendererParams: {
    decimals: 4,
  }
}
export const dashboardConnectionPointIdentification: Columns<any> = {
  title: 'connectionpoint.identification',
  key: 'connectionPointIdentification',
  cellRenderer: LinkCellComponent,
  cellRendererParams: {
    url: '/connectionpoint',
    urlReference: 'connectionPointIdentification',
  }
}

export const dashboardMeterFrameId: Columns<any> = {
  title: 'dashboard.table.meterframeid',
  key: 'meterFrameId'
}

export const dashboardDateForPeak: Columns<any> = {
  title: 'common.date.date',
  key: 'dateForPeak',
  cellRenderer: DateCellComponent
}
export const dashboardMeterFrameMaxCurrent: Columns<any> = {
  title: 'dashboard.table.meterframemaxcurrent',
  key: 'meterFrameMaxCurrent'
}

export const dashboardMeterFrameMaxPower: Columns<any> = {
  title: 'dashboard.table.meterframemaxpower',
  key: 'meterFrameMaxPower'
}

export const dashboardConnectionPointMaxCurrent: Columns<any> = {
  title: 'dashboard.table.connectionpointmaxcurrent',
  key: 'connectionPointMaxCurrent'
}

export const dashboardConnectionPointMaxPower: Columns<any> = {
  title: 'dashboard.table.connectionpointmaxpower',
  key: 'connectionPointMaxPower'
}

export const dashboardPeakConvertedQuantity: Columns<any> = {
  title: 'dashboard.table.peakconvertedquantity',
  key: 'peakConvertedQuantity',
  cellRenderer: DecimalCellComponent,
  cellRendererParams: {
    decimals: 3,
  }
}

export const dashboardTotalPeakConvertedQuantity: Columns<any> = {
  title: 'dashboard.table.totalpeakconvertedquantity',
  key: 'totalPeakConvertedQuantity',
  cellRenderer: DecimalCellComponent,
  cellRendererParams: {
    decimals: 3,
  }
}

export const dashboardServiceRequestCode: Columns<any> = {
  title: 'dashboard.table.serviceRequestCode',
  key: 'serviceRequestCode',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    notspecified: 'enum.serviceRequestCode.notSpecified',
    disconnect: 'enum.serviceRequestCode.disconnect',
    closedown: 'enum.serviceRequestCode.closeDown',
    connect: 'enum.serviceRequestCode.connect',
    readingrequest: 'enum.serviceRequestCode.readingRequest',
    metercheck: 'enum.serviceRequestCode.meterCheck',
    flexchange: 'enum.serviceRequestCode.flexChange',
    nonprofiledchange: 'enum.serviceRequestCode.nonProfiledChange',
    disconnectduetoendofsupply: 'enum.serviceRequestCode.disconnectDueToEndOfSupply',
    themunicipalityisinvolvedinthedisconnection: 'enum.serviceRequestCode.theMunicipalityIsInvolvedInTheDisconnection',
    thepoliceisinvolvedinthedisconnection: 'enum.serviceRequestCode.thePoliceIsInvolvedInTheDisconnection',
    thebailiffscourtisinvolvedinthedisconnection: 'enum.serviceRequestCode.theBailiffsCourtIsInvolvedInTheDisconnection',
    ordinarydisconnectionagreedwiththecustomer: 'enum.serviceRequestCode.ordinaryDisconnectionAgreedWithTheCustomer',
    otherreason: 'enum.serviceRequestCode.otherReason',
    etablishelectricheating: 'enum.serviceRequestCode.establishElectricHeating',
    removeelectricheating: 'enum.serviceRequestCode.removeElectricHeating',
  }
}

export const dashboardIsChild: Columns<any> = {
  ...isChildPartial,
  title: 'dashboard.table.ischild',
  key: 'isChild',
}

export const dashboardhasBalanceSupplier: Columns<any> = {
  ...hasBalanceSupplierPartial,
  title: 'dashboard.table.hasbalancesupplier',
  key: 'hasBalanceSupplier',
}

export const dashboardColumns: Columns<any>[] = [
  dashboardAbsoluteDeviation,
  dashboardActionResponsePartial,
  dashboardBalanceSupplierDate,
  dashboardChangeDate,
  dashboardChargeInformation,
  dashboardChargeInformationIdentification,
  dashboardChargeOccurrences,
  dashboardChargeType,
  dashboardChargeTypeId,
  dashboardCompletionPartial,
  dashboardConnectionPointIdentification,
  dashboardConnectionPointMaxCurrent,
  dashboardConnectionPointMaxPower,
  dashboardConnectivityStatus,
  dashboardConsumptionNonMappedQuadrant,
  dashboardCreatedBy,
  dashboardCreatedPartial,
  dashboardDataHubStatus,
  dashboardDateOfWork,
  dashboardDescription,
  dashboardExistsInDataHub,
  dashboardMeterReadingTs,
  dashboardMeterReadingValue,
  dashboardVerificationMeterReadingValue,
  dashboardLongDescription,
  dashboardMainMeterNumber,
  dashboardMappedQuadrant,
  dashboardMessagesCount,
  dashboardMeterFrameId,
  dashboardMeterFrameMaxCurrent,
  dashboardMeterFrameMaxPower,
  dashboardMeterNumber,
  dashboardMeterReadingOccurrence,
  dashboardMeterType,
  dashboardMeteringPointAddressPartial,
  dashboardMeteringPointIdentificationPartial,
  dashboardMeteringPointTypePartial,
  dashboardMetringPointSubType,
  dashboardModifiedBy,
  dashboardNonMappedQuadrant,
  dashboardObservationPeriod,
  dashboardOccurrence,
  dashboardOldestDayOfWork,
  dashboardOwnerEnergyParty,
  dashboardPartyNamePartial,
  dashboardPeakConvertedQuantity,
  dashboardPhysicalStatusOfMeteringPoint,
  dashboardPhysicalStatusPartial,
  dashboardPipelineTypePartial,
  dashboardAlternateMeterNumber,
  dashboardProductionObligation,
  dashboardQuadrant,
  dashboardReasonTextPartial,
  dashboardReceivingTime,
  dashboardRelativeDeviation,
  dashboardSerialNumber,
  dashboardServiceType,
  dashboardSettlementMethod,
  dashboardStatusPartial,
  dashboardCancelledBySupplierPartial,
  dashboardStatusReasonCode,
  dashboardTotalPeakConvertedQuantity,
  dashboardDateForPeak,
  dashboardUserResponse,
  dashboardValidFrom,
  dashboardValidTo,
  dashboardVerificationMeterNumber,
  dashboardOccurrence,
  dashboardBalanceSupplierDate,
  dashboardServiceRequestCode,
  dashboardCreatedTs,
  dashboardModifiedTs,
  dashboardIsChild,
  dashboardhasBalanceSupplier,
];
